import { getApiRootUrl } from "@shared/utils/api-root-url";
import { useCallback, useState } from "react";
import { Form } from "@shared/components/Form";
import { isValidSsoProvider } from "./login-sso-form-helpers";
import { useLoginOptions } from "./login-options-form-helpers";
import { SubmitButton } from "@avenue-8/sidekick-ui";
import { storeSsoLoginRedirect } from "@shared/utils/sso-login-redirect";

const SSO_BASE_URL = getApiRootUrl();

type Props = {
  provider: string;
  redirect?: string | null;
};

export const LoginSSO = (props: Props) => {
  const { provider, redirect } = props;
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { options: loginOptions } = useLoginOptions();

  const handleContinueClick = useCallback(
    (e: React.FormEvent<HTMLFormElement> | React.MouseEvent) => {
      e.preventDefault();
      if (!isValidSsoProvider(provider, loginOptions)) {
        console.warn(`SSO provider ${provider} is not accepted`);
        return;
      }
      setIsRedirecting(true);
      storeSsoLoginRedirect(redirect ?? null);
      window.location.href = `${SSO_BASE_URL}/auth/login/sso/start?provider=${provider}`;
    },
    [provider, loginOptions, redirect],
  );

  return (
    <>
      <Form aria-disabled={isRedirecting} onSubmit={handleContinueClick}>
        <SubmitButton
          isLoading={isRedirecting}
          onClick={handleContinueClick}
          disabled={!provider}
          type="button"
        >
          Continue
        </SubmitButton>
      </Form>
    </>
  );
};
